import React  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import PendingApprovalsTable from "./components/PendingApprovalsTable"
import UpcomingLeavesTable from "./components/UpcomingLeavesTable"
import UpcomingBirthdaysTable from "./components/UpcomingBirthdaysTable"
import PublicHolidaysTable from "./components/PublicHolidaysTable"
import { LucideCake, LucideCalendar, LucideCalendarDays, LucideCircleAlert } from "lucide-react";
import ThemedSummaryCard from "components/widget/ThemedSummaryCard";



const TeamOverviews = () => {
	return (

    <div>
	    <div>
        <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-4">
          <ThemedSummaryCard
            title={"Upcoming Leaves"}
            icon={<LucideCalendar size={16}/>}
            displayCount={4}
            badgeText={"+2 this week"}
            description={"Next 30 days"}
            colorTheme="flat-blue"
          />	

          <ThemedSummaryCard
            title={"Pending Approvals"}
            icon={<LucideCircleAlert size={16}/>}
            displayCount={4}
            badgeText={"Urgent"}
            description={"Requires action"}
            colorTheme="flat-orange"
          />

          <ThemedSummaryCard
            title={"Upcoming Birthdays"}
            icon={<LucideCake size={16}/>}
            displayCount={5}
            badgeText={"3 this week"}
            description={"This month"}
            colorTheme="flat-purple"
          />		
          <ThemedSummaryCard
            title={"Public Holidays"}
            icon={<LucideCalendarDays size={16}/>}
            displayCount={"12"}
            badgeText={"4 locations"}
            description={"Next 3 months"}
            colorTheme="flat-green"
          />	
          
        </div>
      </div>

      <div className="w-full">
        <Card extra= "mt-5">
          <div className="mt-2 grid grid-cols-2 gap-4 p-2">
              <UpcomingLeavesTable/>
              <PendingApprovalsTable/>
              <UpcomingBirthdaysTable/>
              <PublicHolidaysTable/>
          </div>
        </Card>
      </div>
    </div>
	

      
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TeamOverviews);